import { useQuery } from '@tanstack/react-query'
import * as R from 'remeda'
import { toast } from 'sonner'
import { internal_backend } from '~/internal-backend'

export const GET_SHOPIFY_ORDER_QUERY_KEY = 'get-shopify-order'

export const useGetShopifyOrder = (orderIds: string[]) => {
  return useQuery({
    queryKey: [GET_SHOPIFY_ORDER_QUERY_KEY, orderIds],
    queryFn: async () => {
      const responses = await Promise.all(
        orderIds.map((orderId) => internal_backend.get_order.request(orderId))
      )
      const parsedResponses = responses.map((response) => {
        const parsed = internal_backend.get_order.responseSchema.safeParse(response)
        if (!parsed.success) {
          console.error(parsed.error)
          return { data: null, error: parsed.error }
        }
        return { data: parsed.data.order, error: null }
      })
      const [errors, data] = R.partition(parsedResponses, (response) => response.error !== null)

      errors.forEach((err) => {
        toast.error('Failed to parse Shopify order', { description: err.error.message })
      })

      return data.map((d) => d.data)
    },
    enabled: orderIds.length > 0,
    refetchOnWindowFocus: false,
  })
}
